import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { HomePage, VerificationsPage, } from "./components";
import InnerContent from "./components/InnerContent";

export const AppRoutes = () => {

	return (
		<Routes>
			<Route path="/" element={<InnerContent />}>
				<Route path="/" element={<VerificationsPage />} />
				<Route path="/Verifications" element={<VerificationsPage />} />
				<Route path="*" element={<Navigate to="/NotFound" replace />} />
			</Route>				
		</Routes>
	);
};

export default AppRoutes;
